import Marionette from 'backbone.marionette';
import { Model } from 'backbone';
import { TableLayout } from '../../layouts';
import core_layouts from '../../../../core/layouts';
import { LoadMoreView } from '../../../../core/views/components';
import { isTablet, sizes_for_big_ad, isMobile } from '../../../../core/utils';

import {
	TeamBuilder,
	AdvertisingView,
	RankingsHeader,
	RankingsTable,
	TradeMain,
	TradeInfoBar,
	TradeTeam as TradeTeamView,
	TradeBoard,
	TradePlayerPool,
	TradeHistory,
	TradesView as TradePlaceholderView,
	GlobalNotification,
} from '../../views';

import {
	FantasyTeam,
	TradeTeam as TradeTeamModel,
	Favourites,
	Coach,
	ShareModel,
	Trades,
	CoreRankings,
} from '../../models';

import {
	Rounds,
	Players,
	Squads,
	Positions,
	OverallLadder,
	Venues,
} from '../../collections';

export class FantasyController extends Marionette.Object {
	get rootView() {
		const root_view = this.getOption('rootView');
		root_view.getRegion('global_notification').show(new GlobalNotification());

		return root_view;
	}

	team() {
		const TeamView = new TeamBuilder({
			team: new FantasyTeam(),
			players: new Players(),
			rounds: new Rounds(),
			squads: new Squads(),
			positions: new Positions(),
			favourites: new Favourites(),
			coach: new Coach(),
			share: new ShareModel({
				team_share: true
			}),
			trades: new Trades(),
		});
		const ad_region = isMobile() ? 'ad_container_mobile' : 'ad_container';

		TeamView.getRegion(ad_region).show(new AdvertisingView({
			ad_id: 'my-team-slot-3',
			ad_path: 'my-team/list-view',
			size: sizes_for_big_ad(),
			pos: 1,
		}));

		this.rootView.getRegion('main').show(TeamView);
	}

	trades(player_id) {
		if(isMobile() && !isTablet()){
			// TODO: change back once season start
			const tradePlaceholderView = new TradePlaceholderView({
				model: new Model({ round_id: 1 })
			});
			// tradePlaceholderView.setMobileDeniedTemplate();
			tradePlaceholderView.setPreSeason();
			this.rootView.getRegion('main').show(tradePlaceholderView);

			return this;
		}
		const tradeView = new TradeMain({
			model: new Model(),
			team: new TradeTeamModel(),
			players: new Players(),
			rounds: new Rounds(),
			squads: new Squads(),
			positions: new Positions(),
			favourites: new Favourites(),
			coach: new Coach(),
			trades: new Trades(),
			history: new Trades(),
			venues: new Venues(),
			player_id
		});

		tradeView.on('access:denied', ({ round_id }) => {
			this.rootView.getRegion('main').show(new TradePlaceholderView({
				model: new Model({ round_id })
			}));

			this.rootView.getRegion('top_ads_container').show(new AdvertisingView({
				ad_id: 'my-team-slot-3',
				ad_path: 'my-team/rankings',
				size: sizes_for_big_ad(),
				pos: 3,
			}));
		});

		tradeView.on('end:season', () => {
			const tradePlaceholderView = new TradePlaceholderView();
			tradePlaceholderView.setEndSeason();

			this.rootView.getRegion('main').show(tradePlaceholderView);

			this.rootView.getRegion('top_ads_container').show(new AdvertisingView({
				ad_id: 'my-team-slot-3',
				ad_path: 'my-team/rankings',
				size: sizes_for_big_ad(),
				pos: 3,
			}));
		});

		tradeView.getRegion('info').show(new TradeInfoBar());

		tradeView.getRegion('team').show(new TradeTeamView({
			model: new TradeTeamModel(),
			player_id
		}));

		tradeView.getRegion('controls').show(new TradeBoard({
			model: new Trades()
		}));

		tradeView.getRegion('pool').show(new TradePlayerPool({
			model: new Model()
		}));

		tradeView.getRegion('history').show(new TradeHistory({
			model: new Model()
		}));

		tradeView.getRegion('ad_container').show(new AdvertisingView({
			ad_id: 'my-team-slot-3',
			ad_path: 'my-team/trade-confirmation',
			size: sizes_for_big_ad(),
			pos: 3,
		}));

		this.rootView.getRegion('main').show(tradeView);
	}

	rankings(squad_id) {
		const
			rounds = new Rounds(),
			model = new CoreRankings,
			tableLayout = new TableLayout(),
			fullWidthLayout = new core_layouts.FullWidth(),
			rankingsView = new RankingsTable({
				collection: new OverallLadder(),
				squads: new Squads(),
				rounds,
				model,
				squad_id
			}),
			rankingsHeader = new RankingsHeader({
				rounds,
				model
			}),
			loadMoreView = new LoadMoreView();

		tableLayout.getRegion('table_body').show(rankingsView);
		tableLayout.getRegion('header_page').show(rankingsHeader);
		tableLayout.getRegion('load_more').show(loadMoreView);

		fullWidthLayout.getRegion('content').show(tableLayout);

		this.rootView.getRegion('top_ads_container').show(new AdvertisingView({
			ad_id: 'my-team-slot-3',
			ad_path: 'my-team/rankings',
			size: sizes_for_big_ad(),
			pos: 3,
		}));

		this.rootView.getRegion('main').show(fullWidthLayout);
	}
}

export default FantasyController;